import LoginPage from "../_pages/LoginPage";
import ResetPassword from "../_pages/ResetPassword";

const PublicRoutes = [
  {
    path: "/login",
    element: <LoginPage />,
  },
  // {
  //   path: "/signup",
  //   element: <LoginPage />,
  // },
  {
    path: "/forgot-password",
    element: <ResetPassword />,
  },
];

export default PublicRoutes;
